import { union } from "lodash";
import {ensureType} from "../hooks/ensureType";

export const getApiFieldName = (field: string) => {
	const apiFields = [
		{
			"name": "pubdate",
			"apiName": "timestamp"
		},
		{
			"name": "webPageviews",
			"apiName": "totalWeb"
		},
		{
			"name": "appPageviews",
			"apiName": "totalApp"
		},
		{
			"name": "totalPageviews",
			"apiName": "total"
		},
		{
			"name": "conversion",
			"apiName": "conversion"
		},
		{
			"name": "averageReadingTime",
			"apiName": "readingTimeAverage"
		},
		{
			"name": "totalReadingTime",
			"apiName": "readingTimeTotal"
		},
		{
			"name": "averageReadDepth",
			"apiName": "readDepthAverage"
		},
		{
			"name": "averageScrollDepth",
			"apiName": "scrollDepthAverage"
		},
		{
			"name": "facebookConsumptions",
			"apiName": "facebook_consumptions"
		},
		{
			"name": "facebookLikes",
			"apiName": "facebook_likes"
		},
		{
			"name": "facebookComments",
			"apiName": "facebook_comments"
		},
		{
			"name": "facebookShares",
			"apiName": "facebook_shares"
		},
		{
			"name": "facebookLinkClicks",
			"apiName": "facebook_link_clicks"
		},
		{
			"name": "facebookReach",
			"apiName": "facebook_reach"
		},
		{
			"name": "facebookSocialScore",
			"apiName": "facebook_social_score"
		},
		{
			"name": "twitterLikes",
			"apiName": "twitter_likes"
		},
		{
			"name": "twitterReply",
			"apiName": "twitter_reply"
		},
		{
			"name": "twitterScore",
			"apiName": "twitter_score"
		},
		{
			"name": "linkedinSocial",
			"apiName": "linkedinSocial"
		},
		{
			"name": "socialActions",
			"apiName": "social_actions"
		}
	];

	const column = apiFields.find(apiField => apiField.name === field);

	return column ? column.apiName : field;
};

export const getStoryListFields = (fields: Array<string>) => {
	const defaultFields = [
		'isPaid',
		'hasVideo',
		'brandId',
		'relationId',
		'timestamp',
		'title',
		'user_needs',
		'section',
		'secondary_posts',
		'channels',
		'trend',
		'total'
		// 'conversion'
	];

	const additionalFields = fields.map(field => getApiFieldName(field));

	return union(defaultFields, additionalFields).join(',');
};

export const getListOrder = (order: string) => {
	const field = order.split(".")[0];
	const sort = order.split(".")[1];
	const apiFieldName = getApiFieldName(field);

	return `${apiFieldName}.${sort}`;
}

export const getVideoListOrder = (order: string) => {
	const columns = [
		{
			"name": "pubdate",
			"apiName": "timestamp"
		},
		{
			"name": "total",
			"apiName": "total"
		},
		{
			"name": "totalWeb",
			"apiName": "totalWeb"
		},
		{
			"name": "totalApp",
			"apiName": "totalApp"
		}
	]

	const field = order.split(".")[0];
	const sort = order.split(".")[1];
	const column = ensureType(columns.find(item => item.name === field));

	return `${column.apiName}.${sort}`;
};

export const getDashboardListOrder = (order: string) => {
	const columns = [
		{
			"name": "timestamp",
			"apiName": "timestamp"
		},
		{
			"name": "description",
			"apiName": "description"
		}
	]

	const field = order.split(".")[0];
	const sort = order.split(".")[1];
	const column = ensureType(columns.find(item => item.name === field));

	return `${column.apiName}.${sort}`;
};
